import React, { FC } from 'react';

import { Identity } from '~/types';
import Reset2FAButton from './Reset2FAButton';
import Force2FAButton from './Force2FAButton';
import { useForce2FA, useReset2FA } from '~/hooks/team';

interface Props {
  identityRecord?: Identity;
}

const Manage2FA: FC<Props> = (props) => {
  const { identityRecord } = props;

  const reset2FAMutation = useReset2FA(identityRecord?.id);
  const force2FAMutation = useForce2FA(identityRecord?.id);

  const handleForce2FA = () => {
    if (identityRecord?.id) {
      return force2FAMutation.mutateAsync(identityRecord?.id as any);
    }
  };
  const handleReset2FA = () => {
    if (identityRecord?.id) {
      return reset2FAMutation.mutateAsync(identityRecord?.id as any);
    }
  };

  const is2FaEnabled =
    identityRecord?.totp ||
    !!(identityRecord?.requiredActions || []).find((item) => item === 'CONFIGURE_TOTP');

  if (is2FaEnabled) {
    return <Reset2FAButton onClick={handleReset2FA} />;
  }
  return <Force2FAButton onClick={handleForce2FA} />;
};

export default Manage2FA;
